
export const slicedAddress = (account: string | any[]):string  => {
  return `${account.slice(0, 6)}...${account.slice(-4)}`;
};

export default {
  slicedAddress,
};
